import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs';

import 'rxjs/add/operator/first';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/groupBy';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/do';

@Injectable()
export class YearsService {
  projects: any[];
  years: Observable<any[]>;
  constructor(private db:AngularFireDatabase) {}

  // getYears():Observable<any[]>{
  //   return this.db.list('years', ref => ref.orderByChild('category').equalTo('project'))
  //   .valueChanges()
  //   .first()
  //   .toArray()
  // }

  findAllYears(): Observable<any[]> {
    // get year information for side menu
    return this.db.list('links')
      .valueChanges()
      .first()
  }

}


// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/services/years.service.ts